import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { ColumnData as CD } from 'ui/tableHeader';
import {
  ImageAttrs,
  ImageAttrBatch,
  LinkAttrs,
  LinkAttrBatch,
  MovableInkModal,
  SortableField,
} from './constants';

export enum PanelIntent {
  // Browse = 'browse',
  Edit = 'edit',
  Insert = 'insert',
  Select = 'select',
}

export type AssetRequestConfig = {
  append?: boolean; // append results in endless scroll
  campaignId: string; // limits results to a MI Campaign
  page: number;
  pageSize: number;
  search: string;
  sortBy?: SortableField | string; // enum of field to sort by
  sortDirection?: SORT_DIRECTIONS; // enum of sort direction
};

export type ImageMetadataParams = {
  height: number; // in px
  name: string;
  naturalAspectRatio: number;
  width: number; // in px
};

export type CreatedImageMetadata = ImageMetadataParams & {
  campaignId: number; // MI campaign ID
  created: string;
};

export type ImageMetadata = ImageMetadataParams | CreatedImageMetadata;

export enum MovableInkIntegrationColumn {
  tokenId = 'tokenId',
  name = 'name',
  accountId = 'accountId',
  createdBy = 'createdBy',
  createdAt = 'createdAt',
  updatedAt = 'updatedAt',
}

export type MovableInkIntegration = {
  tokenId: number;
  name: string;
  createdAt: string;
  updatedAt: string;
  accountId?: string;
  createdBy?: string;
  createdByUser?: {
    id: string;
    fullName: string;
  };
};

export type MovableInkChildIntegration = {
  companyId: number;
  name: string;
  isDefault: boolean;
};

export type MovableInkBlock = {
  id: number;
  name: string;
  created: string;
  updated: string;
  embedCode: string;
  imageUrl: string;
  altText: string;
  campaignId?: number;
  aHref?: string;
};

export type MovableInkCampaign = {
  id: number;
  name: string;
  created: string;
  updated: string;
};

export type AddAccountModalState = {
  modalId: MovableInkModal;
  code: string;
};

export type DeleteAccountModalState = {
  modalId: MovableInkModal;
  id: number;
  name: string;
};

export type MovableInkModalState = AddAccountModalState | DeleteAccountModalState;

export type MovableInkIntegrationTableColumnData = CD & {
  RowCell: ({ row }: { row: MovableInkIntegration }) => React.ReactElement;
};

export type ImageAttrAction =
  | { type: ImageAttrs; value: string }
  | { type: ImageAttrBatch; value: Partial<ImageAttrState> };

export type ImageAttrState = {
  [ImageAttrs.ALT_DESC]: string;
  [ImageAttrs.BORDER]: string;
  [ImageAttrs.HEIGHT]: string;
  [ImageAttrs.SOURCE]: string;
  [ImageAttrs.STYLES]: string;
  [ImageAttrs.WIDTH]: string;
};

export type LinkAttrAction =
  | { type: LinkAttrs; value: string }
  | { type: LinkAttrBatch; value: Partial<LinkAttrState> };

export type LinkAttrState = {
  [LinkAttrs.HREF]: string;
  [LinkAttrs.STYLES]: string;
};

export type Asset = {
  aHref: string;
  campaignId: string; // MI campaign ID
  created: string;
  embedCode: string;
  id: string;
  imgSrc: string;
  name: string;
  updated: string;
};

export type Info = {
  page: number;
  pageSize: number;
  totalPages: number;
};

export type Pagination = {
  page: number;
  pageSize: number;
};

export type Sort = {
  sortBy: SortableField;
  sortDirection: SORT_DIRECTIONS;
};

export type ResolveImgData = (img: HTMLImageElement) => void;
